// extracted by mini-css-extract-plugin
export default {"section":"rXtZCu0","headline":"VadGnZS","button":"U1dBwEr"};